import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import useUserStore from '../store/userStore';
import LoginPageComponent from '../components/login/LoginPage';
import { SCHOOL_CONFIG } from '../config/appConfig';
import useSchoolStore from '../store/schoolStore';
import ErrorWidget from '../components/common/ErrorWidget';
import LoadingMessage from '../components/common/LoadingMessage';

const LoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // The auth listener is started once in App.js (useAuthStore.initAuthListener)
  const { isAuthenticated } = useAuthStore();
  const {isUserLoggedIn, userProfile, logoutError, logoutUser, isLoading} = useUserStore();
  const {schoolId} = useSchoolStore();
  
  const [isValidSchool, setIsValidSchool] = useState(true);
  useEffect(() => {
   
    // Redirect if already authenticated
    if (isAuthenticated) {
      ///Next check if the user is logged in as well.
      if(isUserLoggedIn){
        // Get the redirect URL from query params
      const redirectUrl = searchParams.get('redirect');
   
      
      // Only redirect if school IDs match
      if (isValidSchool) {
        if (redirectUrl) {
          // Decode and navigate to the original URL
          const decodedUrl = decodeURIComponent(redirectUrl);
          navigate(decodedUrl, { replace: true });
        } else {
          navigate(`/dash/${userProfile.schoolId}`, { replace: true });
        }
      } else {
        // School IDs don't match - logout user and handle the response
        console.warn(`User school ID (${userProfile.schoolId}) doesn't match URL school ID (${schoolId})`);
        setIsValidSchool(false);
      }
      }else{

      }
      
    }
  }, [isAuthenticated, searchParams, isUserLoggedIn, userProfile, schoolId]);



  // Show loading spinner while handling logout
  if ((isLoading && !isValidSchool)) {
    return (
      <LoadingMessage 
        message="Signing out..."
        className="min-h-screen"
      />
    );
  }

  // Show error widget if logout failed
  if (logoutError) {
    return (
      <ErrorWidget 
        error={logoutError}
        title="Logout Failed"
      />
    );
  }

  // Don't render login page if already authenticated
  if (isAuthenticated && isUserLoggedIn && isValidSchool) {
    return null;
  }

  return <LoginPageComponent />;
};

export default LoginPage; 